import { useState } from "react";

import type { DateRange } from "react-day-picker";

import { DatePickerWithRange } from "@/shared/ui/date-picker-range";
import { Modal } from "@/shared/ui/Modal";
import { Checkbox } from "@/shared/ui/checkbox";
import { useSMSExport } from "@/entities/sms";
import { Button } from "@/shared/ui/button";

export const PhonesExportModal = () => {
  const [date, setDate] = useState<DateRange | undefined>();
  const [exportAllTime, setExportAllTime] = useState(false);

  const { mutateAsync: exportSMS } = useSMSExport();

  const handleCheckboxChange = () => {
    setExportAllTime((prev) => !prev);
    if (!exportAllTime) {
      setDate(undefined);
    }
  };

  return (
    <Modal>
      <Modal.Trigger>Выкачка номеров</Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Выкачка номеров</Modal.Title>
        <DatePickerWithRange date={date} setDate={setDate} />
        <div className="flex items-center gap-2 text-textColor">
          <Checkbox
            checked={exportAllTime}
            onCheckedChange={handleCheckboxChange}
          />
          За все время
        </div>

        <Button
          onClick={async () => {
            const blob = await exportSMS({
              fromDate: date?.from,
              toDate: date?.to,
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }}
        >
          Выгрузить
        </Button>
      </Modal.Content>
    </Modal>
  );
};
